import { render, staticRenderFns } from "./dibang.vue?vue&type=template&id=f427b176&scoped=true"
var script = {}
import style0 from "./dibang.vue?vue&type=style&index=0&id=f427b176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f427b176",
  null
  
)

export default component.exports